var __rspack_ns_object = JSON.parse('{"Studies":"检查","Measurements":"测量","Measure":"测量","Segmentation":"分割"}')